export var gdPrefix = 'gd';
export var getPrefixCls = function getPrefixCls(name) {
  return "".concat(gdPrefix, "-").concat(name);
};
export var filterChinese = function filterChinese(str) {
  return str.replace(/[^\x00-\xff]/g, '');
};
export var jumpEventClick = function jumpEventClick(config, switchConfig) {
  var _ref = config || {},
    openSwitch = _ref.openSwitch,
    switchType = _ref.switchType,
    url = _ref.url,
    anchorUrl = _ref.anchorUrl,
    appId = _ref.appId,
    customUrl = _ref.customUrl,
    wechatService = _ref.wechatService,
    videoAppId = _ref.videoAppId,
    videoId = _ref.videoId,
    feedId = _ref.feedId,
    appointmentAppId = _ref.appointmentAppId,
    appointProjectId = _ref.appointProjectId,
    appointmentVideoId = _ref.appointmentVideoId,
    videoTime = _ref.videoTime;
  if (!openSwitch) return;
  var _ref2 = switchConfig || {},
    open = _ref2.open,
    scrollToAnchor = _ref2.scrollToAnchor,
    openModal = _ref2.openModal,
    jumpApplet = _ref2.jumpApplet,
    jumpWechatService = _ref2.jumpWechatService,
    openWechatVideo = _ref2.openWechatVideo,
    reserveChannelsLive = _ref2.reserveChannelsLive;
  switch (switchType) {
    // 普通链接跳转
    case 'url':
      if (!url) break;
      open === null || open === void 0 ? void 0 : open(url);
      break;
    // 锚点跳转
    case 'anchor':
      if (!anchorUrl) break;
      scrollToAnchor === null || scrollToAnchor === void 0 ? void 0 : scrollToAnchor(anchorUrl);
      break;
    case 'pageModal':
      openModal === null || openModal === void 0 ? void 0 : openModal();
      break;
    case 'jumpApplet':
      if (!appId) break;
      jumpApplet === null || jumpApplet === void 0 ? void 0 : jumpApplet(appId, customUrl);
      break;
    case 'wechatService':
      if (!wechatService) break;
      jumpWechatService === null || jumpWechatService === void 0 ? void 0 : jumpWechatService(wechatService);
      break;
    case 'video':
      if (!videoAppId) break;
      openWechatVideo === null || openWechatVideo === void 0 ? void 0 : openWechatVideo({
        videoAppId: videoAppId,
        videoId: videoId,
        feedId: feedId
      });
      break;
    case 'videoAppointment':
      if (!appointmentAppId) break;
      reserveChannelsLive === null || reserveChannelsLive === void 0 ? void 0 : reserveChannelsLive({
        appointmentAppId: appointmentAppId,
        appointProjectId: appointProjectId,
        appointmentVideoId: appointmentVideoId,
        videoTime: videoTime
      });
      break;
    default:
      if (!url) break;
      open === null || open === void 0 ? void 0 : open(url);
      break;
  }
};
export var getRandomHexColor = function getRandomHexColor() {
  // 生成一个随机的 RGB 颜色，范围在 150 到 255 之间，避免颜色过于艳丽
  var r = Math.floor(Math.random() * 105) + 150;
  var g = Math.floor(Math.random() * 105) + 150;
  var b = Math.floor(Math.random() * 105) + 150;

  // 将 RGB 颜色转换为十六进制颜色
  var hex = function hex(value) {
    return value.toString(16).padStart(2, '0');
  };
  return "#".concat(hex(r)).concat(hex(g)).concat(hex(b));
};